module.exports = function() {
    'use strict';
    var baggageRowsCollection = require('../../modules/collections/baggages_rows').getInstance();
    var baggageOptionsCollection = require('../../modules/collections/baggages_row_options').getInstance();

    return Odigeo.View.extend({
        templateSettings: Odigeo.Utils.getTmplSettings({variable: ''}),
        sidebarSegmentOrder: ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'FIFTH', 'SIXTH'],
        selectors: {
            baggageWrapper: '.baggage_summary_wrapper',
            baggageInfo: '.baggage_info',
            baggageFeeHintContainer: '.baggage_fee_hint_container',
            baggageFeeHintText: '.baggage_fee_hint_text',
        },
        MAX_BAGGAGE_WEIGHT: 32,
        onUpdateBaggages: function() {
            this.updateBaggageSection();
            this.renderBaggageDisclaimer();
        },
        updateBaggageSection: function() {
            var piecesBySegment = this.getAllPiecesBySegmentAndWeight();

            var isItineraryTrip = baggageRowsCollection.isAnItineraryTrip() && Odigeo._.size(piecesBySegment) === 1;
            var flightType = isItineraryTrip ? 'ROUND_TRIP' : baggageRowsCollection.getRequestType();

            if (isItineraryTrip) {
                piecesBySegment = {
                    FIRST: Odigeo._.clone(piecesBySegment['FIRST']),
                    SECOND: Odigeo._.extend(piecesBySegment['FIRST'], {segmentId: 'SECOND'}),
                };
            }

            this.printBaggageSection(piecesBySegment, flightType);
        },
        renderBaggageDisclaimer: function() {
            var numberPieces = this.getNumberBaggagePieces();
            var fee = this.widget.getSelectedBaggageAverageFee();
            this.$cachedSelectors.baggageFeeHintText.html(Odigeo.Utils.replaceCmsKeyArgs(this.keys.baggageFeeDisclaimer, fee));
            this.$cachedSelectors.baggageFeeHintContainer.toggleClass('odf-hidden', numberPieces === 0 || fee === 0);
        },
        enhanceBaggageFeeTooltip: function() {
            if (this.$cachedSelectors.baggageFeeHintContainer.length) {
                Odigeo.UIElements.hint.enhance(
                    Odigeo.History.getPageNameFromFragment(),
                    this.$cachedSelectors.baggageFeeHintContainer, {
                        events: {
                            tap: true,
                        },
                    });
            }
        },
        printBaggageSection: function(piecesBySegment, flightType) {
            var selectedBaggageTotalPrice = Odigeo.Utils.formatCurrency(baggageOptionsCollection.selectedTotalPrice);
            var selectedBaggageTotalPricePlusDiscount = Odigeo.Utils.formatCurrency(baggageOptionsCollection.selectedTotalPricePlusDiscount);

            this.$cachedSelectors.baggageInfo.html(this.templates.segment({
                piecesBySegment: piecesBySegment,
                showAsteriskLegend: this.showAsteriskLegend(piecesBySegment),
                selectedBaggageTotalPrice,
                selectedBaggageTotalPricePlusDiscount,
                showSelectedBaggageTotalPrice: this.shouldShowSelectedBaggageTotalPrice(),
                segmentNames: this.segmentNames[flightType],
                keys: this.keys,
                getPromotionMerchandisingBadge: baggageOptionsCollection.isBaggagePropensityLowForMerchandisingDiscount(),
                discount: baggageOptionsCollection.getDiscount(),
                areAllPassengersWithBaggage: baggageOptionsCollection.areAllPassengersWithBaggage(),
            }));
        },
        shouldShowSelectedBaggageTotalPrice: function() {
            return baggageOptionsCollection.selectedTotalPrice > 0;
        },
        showAsteriskLegend: function(piecesBySegment) {
            return Odigeo._.some(piecesBySegment, function(segmentData) {
                return segmentData.showAsteriskLegend;
            });
        },
        getNumberBaggagePieces: function() {
            return Odigeo.AB.isItineraryBagPriceSplitDesktop
                ? this.widget.calculateTotalQuantity()
                : this.widget.getBaggageSelectedPieces();
        },
        getAllPiecesBySegmentAndWeight: function() {
            var result = {};

            this.setEmptySegmentData(result);

            Odigeo._.each(baggageOptionsCollection.getAllPiecesBySegment(), function(segment, segmentId) {
                result[segmentId] = this.getSegmentData(segment, segmentId);
            }, this);

            return result;
        },
        getSegmentData: function(segment, segmentId) {
            var MAX_BAGGAGE_WEIGHT = this.MAX_BAGGAGE_WEIGHT;
            var data = Odigeo._.reduce(segment, function(segmentData, option) {
                var isIncludedBaggage = option.get('isIncludedBaggage');
                var isSelectableBaggage = option.get('isSelectableBaggage');
                var piecesToShow = option.get('piecesToShow');
                var weight = parseFloat(option.get('kilosPerPiece'));
                var isWeightBased = segmentData.isWeightBased || option.get('isWeightBased');
                var piecesPerWeight = segmentData.piecesPerWeight;
                var realPieces = parseFloat(isIncludedBaggage ? option.get('pieces') : piecesToShow);
                const transportType = baggageRowsCollection.getRow({idRow: option.get('idRow')}).get('transportType');
                if (Odigeo.AB.isDisplayTotalBaggageWeightAllowance && option.get('kilos') < MAX_BAGGAGE_WEIGHT) {
                    weight = weight / option.get('pieces');
                }

                piecesPerWeight[weight] = (piecesPerWeight[weight] || 0) + realPieces;

                Odigeo._.extend(segmentData, {
                    weight: segmentData.weight + weight,
                    pieces: segmentData.pieces + realPieces,
                    piecesToShow: segmentData.piecesToShow + piecesToShow,
                    piecesPerWeight: piecesPerWeight,
                    isWeightBased: isWeightBased,
                    isIncludedBaggage: segmentData.isIncludedBaggage || isIncludedBaggage,
                    isSelectableBaggage,
                    showAsteriskLegend: isWeightBased && weight > MAX_BAGGAGE_WEIGHT,
                    hasPieces: segmentData.hasPieces || realPieces > 0,
                    transportType,
                });

                return segmentData;
            }, this.getEmptySegmentData(segmentId));

            data.piecesPerWeight = this.groupPieces(data);

            return data;
        },
        groupPieces: function(data) {
            var groupedPieces = [];

            Odigeo._.each(data.piecesPerWeight, function(pieces, weight) {
                if (pieces > 0) {
                    groupedPieces.push(this.addOptionType({
                        pieces: pieces,
                        weight: parseFloat(weight),
                        hasPieces: data.hasPieces,
                        isWeightBased: data.isWeightBased,
                        showAsteriskLegend: data.showAsteriskLegend,
                    }));
                }
            }, this);

            return Odigeo._.isEmpty(groupedPieces)
                ? this.getEmptySegmentBaggage()
                : this.sortPieces(groupedPieces);
        },
        addOptionType: function(option) {
            if (!option.hasPieces) {
                return option;
            }

            if (option.weight === 0) {
                option.label = this.getNoWeightLabel(option);
            } else {
                option.label = option.isWeightBased
                    ? this.getWeightBasedLabel(option)
                    : this.getWithWeightLabel(option);
            }

            return option;
        },
        getWithWeightLabel: function(option) {
            const totalWeightMultiplePieces = option.weight * option.pieces;
            const weightOnePiece = option.weight;

            if (Odigeo.AB.isDisplayTotalBaggageWeightAllowance && option.pieces > 1) {
                return Odigeo.Utils.pluralizeAll(this.keys.piecesWithTotalKilos, option.pieces, totalWeightMultiplePieces);
            } else {
                return [option.pieces, Odigeo.Utils.pluralizeAll(this.keys.piecesWithKilos, option.pieces, weightOnePiece)].join(' ');
            }
        },
        getWeightBasedLabel: function(option) {
            const weightOnePiece = option.weight;
            return [
                Odigeo.Utils.pluralizeAll(this.keys.totalWeight, weightOnePiece, option.pieces),

                option.showAsteriskLegend ? '*' : '',
            ].join(' ');
        },
        getNoWeightLabel: function(option) {
            return [
                option.pieces,
                Odigeo.Utils.pluralizeAll(this.keys.piecesWithoutKilos, option.pieces, option.weight),
            ].join(' ');
        },
        getEmptySegmentBaggage: function() {
            return [{
                pieces: 0,
                weight: 0,
            }];
        },
        sortPieces: function(elements) {
            elements.sort(function(a, b) {
                return a.weight - b.weight;
            });

            return elements;
        },
        getEmptySegmentData: function(segmentId) {
            return {
                weight: 0,
                pieces: 0,
                piecesToShow: 0,
                piecesPerWeight: {},
                isIncludedBaggage: false,
                isWeightBased: false,
                segmentId: segmentId,
            };
        },
        setEmptySegmentData: function(data) {
            Odigeo._.each(baggageRowsCollection.getRowIds(), function(rowId) {
                data[rowId] = {
                    weight: 0,
                    pieces: 0,
                    piecesToShow: 0,
                    isIncludedBaggage: false,
                    isSelectableBaggage: false,
                    isWeightBased: false,
                    segmentId: rowId,
                };
            });
        },
        init: function() {
            this.initSegmentNames();
        },
        initSegmentNames: function() {
            this.segmentNames = {
                ONE_WAY: {
                    FIRST: this.keys.flightOutbound,
                },
                ROUND_TRIP: {
                    ITINERARY: this.keys.flightItinerary,
                    FIRST: this.keys.flightOutbound,
                    SECOND: this.keys.flightInbound,
                },
                MULTIPLE_DESTINATIONS: {
                    FIRST: this.keys.flightFirst,
                    SECOND: this.keys.flightSecond,
                    THIRD: this.keys.flightThird,
                    FOURTH: this.keys.flightFourth,
                    FIFTH: this.keys.flightFifth,
                    SIXTH: this.keys.flightSixth,
                },
            };
        },
    });
}();
